import { Conversation } from '@/_types/models/conversations';
import { moment } from './dates';

export const getAllConversationNames = (
  conversation?: Conversation,
  isAdvisor?: boolean,
): Array<string> => {
  const allNamesForClient: Array<string> = [
    ...(conversation?.advisor_names || []),
    ...(conversation?.client_names || []),
  ];

  const conversationNames: Array<string> = isAdvisor
    ? conversation?.client_names || []
    : allNamesForClient;

  return conversationNames;
};

export const getExportTimestamp = (
  selectedTimestamp: string,
): { start_date: string | undefined; end_date: string | undefined } => {
  let start_date;
  let end_date;

  switch (selectedTimestamp) {
    case 'this_week':
      start_date = moment().clone().startOf('week');
      end_date = moment().clone().endOf('week');
      break;
    case 'last_week':
      start_date = moment().subtract(1, 'week').clone().startOf('week');
      end_date = moment().subtract(1, 'week').clone().endOf('week');
      break;
    case 'last_month':
      start_date = moment().subtract(1, 'month').clone().startOf('month');
      end_date = moment().subtract(1, 'month').clone().endOf('month');
      break;
    case 'last_quarter':
      start_date = moment().subtract(1, 'quarter').clone().startOf('quarter');
      end_date = moment().subtract(1, 'quarter').clone().endOf('quarter');
      break;
    case 'last_year':
      start_date = moment().subtract(1, 'year').clone().startOf('year');
      end_date = moment().subtract(1, 'year').clone().endOf('year');
      break;
    default:
      start_date = undefined;
      end_date = undefined;
  }

  if (start_date) {
    start_date = start_date.format('DD-MM-YYYY');
  }

  if (end_date) {
    end_date = end_date.format('DD-MM-YYYY');
  }

  return { start_date, end_date };
};
